// src/components/MiniToolsPreview.js
import React from 'react';
import { Link } from 'react-router-dom';
import { IoImageOutline, IoFilmOutline, IoChatbubblesOutline, IoSwapHorizontalOutline } from 'react-icons/io5';

const tools = [
  {
    icon: IoImageOutline,
    title: 'Image BG Remover',
    description: 'Instantly remove the background from any image with a single click. Perfect for product photos and portraits.',
    to: '/bg-remover',
  },
  {
    icon: IoFilmOutline,
    title: 'Video BG Remover',
    description: 'Automate video background removal without complex green screens. Ideal for creating professional clips.',
    to: '/video-bg-remover',
  },
  {
    icon: IoChatbubblesOutline,
    title: 'AI Caption Generator',
    description: 'Generate engaging, platform-specific captions and hashtags for your social media posts in seconds.',
    to: '/caption-generator',
  },
  {
    icon: IoSwapHorizontalOutline,
    title: 'Any-to-Any Converter',
    description: 'Effortlessly convert images, videos, audio, and documents between dozens of formats.',
    to: '/any-to-any-converter',
  },
];

const MiniToolsPreview = () => {
  return (
    <section className="py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto max-w-2xl lg:text-center">
          <h2 className="text-base font-semibold leading-7 bg-gradient-to-r from-dark-accent-start to-dark-accent-end bg-clip-text text-transparent">
            Your Creative Toolkit
          </h2>
          <p className="mt-2 text-3xl font-bold tracking-tight text-dark-text-primary sm:text-4xl">
            Powerful mini-tools, free to use.
          </p>
          <p className="mt-6 text-lg leading-8 text-dark-text-secondary">
            Go beyond social media management with a suite of AI-powered tools designed to streamline your entire creative workflow.
          </p>
        </div>
        <div className="mx-auto mt-16 grid max-w-lg grid-cols-1 gap-8 sm:mt-20 lg:max-w-none md:grid-cols-2">
          {tools.map((tool) => (
            <Link
              key={tool.title}
              to={tool.to}
              className="group flex flex-col items-start p-8 bg-dark-card/40 backdrop-blur-lg rounded-2xl border border-white/10 transform-gpu transition-all duration-300 ease-in-out hover:scale-105 hover:border-dark-accent-start/50 hover:shadow-2xl hover:shadow-dark-accent-start/10"
            >
              <div className="flex h-14 w-14 items-center justify-center rounded-2xl bg-gradient-to-br from-dark-accent-start to-dark-accent-end mb-6">
                <tool.icon className="h-8 w-8 text-white" aria-hidden="true" />
              </div>
              <h3 className="text-lg font-semibold text-dark-text-primary group-hover:text-white">
                {tool.title}
              </h3>
              <p className="mt-2 text-sm text-dark-text-secondary">
                {tool.description}
              </p>
            </Link>
          ))}
        </div>
        <div className="text-center mt-16">
            <Link to="/mini-tools" className="text-sm font-semibold text-dark-text-primary hover:text-white">
                Explore all 50+ mini-tools &rarr;
            </Link>
        </div>
      </div>
    </section>
  );
};

export default MiniToolsPreview;